import http from "./http";

const UrlAddition: string = `/tournament`;

type TournamentInfo = {
  tournament_players_already_registered: number;
  tournament_max_players: number;
};

// Create a new type that includes the "response" field
type TournamentInfoResponse = {
  response: TournamentInfo;
};

// Response type for latest tournament endpoint
export type TournamentDTO = {
  tournament_id: number;
  tournament_name: string;
  tournament_date: string; // ISO string
  max_players: number;
  numberOfRegisteredPlayers: number;
};

export type TournamentType = TournamentDTO & {
  formatted_date: string; // in nl-BE format e.g. "23 augustus 2024"
  formatted_time: string; // 13:00:00 -> 13u00
  formatted_registration_deadline: string; // e.g., "09 augustus 2024"
};

export async function getTournamentRegisteredPlayersCount(tournament_id: number) {
  try {
    const response = await http.get<TournamentInfoResponse>(`${UrlAddition}/numberofplayers`, {
      params: { tournament_id: tournament_id },
    });
    if (response.status === 200) {
      //console.log("TournamentInfo in service/tournament.tsx:", response.data);
      return response.data.response; // Access the "response" field of the data
    } else {
      throw response;
    }
  } catch (error: any) {
    console.error(error.response);
    throw error.response;
  }
}

export async function getLatestTournamentInfo(): Promise<TournamentType | null> {
  try {
    const response = await http.get<TournamentDTO>(`${UrlAddition}/latesttournamentinfo`);
    if (response.status === 200) {
      const tournament = response.data;
      const tournamentDate = new Date(tournament.tournament_date);

      // Format full date (e.g. "23 augustus 2024")
      const formattedDate = new Intl.DateTimeFormat("nl-BE", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(tournamentDate);

      // Format time as "13u00"
      const hours = tournamentDate.getHours().toString().padStart(2, "0");
      const minutes = tournamentDate.getMinutes().toString().padStart(2, "0");
      const formattedTime = `${hours}u${minutes}`;

      // Calculate registration deadline (14 days before)
      const deadlineDate = new Date(tournamentDate);
      deadlineDate.setDate(tournamentDate.getDate() - 14);

      const formattedDeadline = new Intl.DateTimeFormat("nl-BE", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(deadlineDate);

      return {
        ...tournament,
        formatted_date: formattedDate,
        formatted_time: formattedTime,
        formatted_registration_deadline: formattedDeadline,
      };

    } else if (response.status === 204) {
      return null;
    } else {
      throw response;
    }
  } catch (error: any) {
    console.error(error.response);
    throw error.response;
  }
}